import { z } from 'zod';
/** An MCP client (Claude, ChatGPT, ...) the user authorized against the Corso MCP server; the user-level twin of a store identity grant. */
export const userMcpIdentityGrant = z.object({
    id: z.number(),
    clientId: z.string(),
    /** The client's display name in Auth0; null until the first lookup. */
    name: z.string().nullable(),
    createdOn: z.string(),
    lastUsedOn: z.string(),
});
export const userMcpIdentityGrants = z.object({
    grants: z.array(userMcpIdentityGrant),
});
//# sourceMappingURL=mcpIdentityGrant.js.map